import classnames from 'classnames';
import createReactClass from 'create-react-class';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Calendar } from 'react-date-range';

import Button, { ButtonTypes } from 'components/common/button';
import KeypressGlobalMixin from 'components/lib/keypress_global_mixin';
import OutsideClickHandler from 'components/common/utilities/outside_click_handler';
import PopoverCard from 'components/common/popover_card';

export const DatePickerMenu = createReactClass({
  mixins: [KeypressGlobalMixin],

  propTypes: {
    className: PropTypes.string,
    date: PropTypes.string,
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    placeholderText: PropTypes.string,
  },

  getInitialState() {
    return { isPickerVisible: false };
  },

  togglePicker(evt) {
    evt.preventDefault();
    if (this.props.isDisabled) {
      this.setState({ isPickerVisible: false });
    } else {
      this.setState(prevState => ({ isPickerVisible: !prevState.isPickerVisible }));
    }
  },

  onCancel(e) {
    if (this.state.isPickerVisible) {
      this.handleClose();
      this.stopEvent(e);
    }
  },

  handleClose() {
    this.setState({ isPickerVisible: false });
  },

  handleSubmit(date) {
    this.props.onChange(date);
    this.handleClose();
  },

  render() {
    let classes = classnames('datePicker', this.props.className, {
      'datePicker-open': this.state.isPickerVisible,
      'datePicker-disabled': this.props.isDisabled,
    });

    const opener = this.opener;
    return (
      <div className={classes}>
        <div className="datePicker-opener" onMouseDown={this.togglePicker} ref={node => (this.opener = node)}>
          {this.renderMenuOpener()}
        </div>
        <PopoverCard
          bounds={{ top: 10 }}
          className="datePicker-popoverCard"
          isVisible={this.state.isPickerVisible}
          position="right"
          targetElement={opener}
        >
          <OutsideClickHandler onClickOutside={this.handleClose}>
            <DatePicker
              button={opener}
              date={this.props.date}
              isDisabled={this.props.isDisabled}
              onClose={this.handleClose}
              onSubmit={this.handleSubmit}
            />
          </OutsideClickHandler>
        </PopoverCard>
      </div>
    );
  },

  renderMenuOpener() {
    return this.props.date ? this.renderSelectedDate() : this.renderDefaultText();
  },

  renderSelectedDate() {
    return (
      <div className="datePicker-selection">
        <div className="datePicker-selection-date">{moment(this.props.date).format('MMM D, YYYY')}</div>
      </div>
    );
  },

  renderDefaultText() {
    const classNames = classnames('datePicker-defaultText', {
      'datePicker-defaultText-open': this.state.isPickerVisible,
    });
    return (
      <span className={classNames}>
        <i className="fa fa-calendar-o datePicker-defaultText-icon" />
        {this.props.placeholderText ? this.props.placeholderText : 'Enter a date'}
      </span>
    );
  },

  preventDefault(evt) {
    evt.preventDefault();
  },
});

export const DatePicker = createReactClass({
  propTypes: {
    button: PropTypes.any,
    date: PropTypes.string,
    isDisabled: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  },

  getInitialState() {
    return { date: this.props.date ? this.props.date : moment().toISOString() };
  },

  onChangeDate(date) {
    this.setState({ date });
  },

  render() {
    return (
      <div className="datePicker-picker" ref={node => (this.picker = node)}>
        <CalendarPicker date={this.state.date} onChange={this.onChangeDate} />
        <div className="datePicker-buttons">
          <Button
            className="datePicker-date-clear"
            onClick={this.handleClearDate}
            buttonType={ButtonTypes.TEXT}
            disabled={this.props.isDisabled}
          >
            Clear
          </Button>
          <Button
            className="datePicker-date-apply"
            onClick={this.handleApplyChanges}
            buttonType={ButtonTypes.PRIMARY}
            disabled={this.props.isDisabled}
          >
            Apply
          </Button>
        </div>

        <div className="datePicker-picker-leftTriangle" ref={node => (this.triangle = node)}>
          <div className="datePicker-picker-leftTriangle-border" />
        </div>
      </div>
    );
  },

  handleApplyChanges() {
    this.props.onSubmit(this.state.date);
  },

  handleClearDate() {
    this.props.onSubmit('');
  },
});

export const CalendarPicker = createReactClass({
  propTypes: {
    date: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  },

  render() {
    return (
      <Calendar
        date={moment(this.props.date)}
        onChange={this.onChange}
        theme={{
          Calendar: {
            background: null,
            borderRadius: null,
            color: null,
            padding: '0px',
          },
          MonthAndYear: {
            color: null,
            fontSize: null,
          },
          MonthButton: {
            background: null,
          },
          Weekday: {
            color: null,
            fontWeight: null,
          },
          DayPassive: {
            color: null,
          },
          DaySelected: {
            background: null,
            color: null,
          },
        }}
      />
    );
  },

  onChange(value) {
    this.props.onChange(value.toISOString());
  },
});

export default DatePickerMenu;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/date_picker_menu.jsx